import React, { useState, useEffect, memo } from "react";
import "./ProductCard.css";
import Button from "../Button/Button";
import LikeButton from "../LikeButton/LikeButton";

import imageCompression from "browser-image-compression";

async function compressImage(imageUrl) {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 550,
      useWebWorker: true,
    };

    const compressedBlob = await imageCompression(blob, options);
    return URL.createObjectURL(compressedBlob);
  } catch (error) {
    console.error("Ошибка сжатия изображения:", error);
    return imageUrl;
  }
}

const ProductCard = memo(({
  id,
  image,
  name,
  size,
  gramm,
  description,
  price,
  setProduct,
  old_price,
  category,
  isHit = false,
  isNew = false,
  collectionName = "products",
  likes = 0,
}) => {
  const [compressedImage, setCompressedImage] = useState(image);
  const [imageLoaded, setImageLoaded] = useState(false);
  
  const isSoon = category === "soon";
  const discount = old_price ? Math.round(((old_price - price) / old_price) * 100) : 0;

  useEffect(() => {
    let isMounted = true;
    
    async function optimizeImage() {
      const optimized = await compressImage(image);
      if (isMounted) {
        setCompressedImage(optimized);
      }
    }
    
    optimizeImage();
    
    return () => {
      isMounted = false;
    };
  }, [image]);

  const handleOrderClick = () => {
    if (typeof setProduct === "function") {
      setProduct({
        id, name, size, gramm, description, price, category
      });
    }
    
    const orderSection = document.getElementById("Order");
    if (orderSection) {
      orderSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className={`product-cards ${isSoon ? 'soon' : ''}`}>
      
      {/* Изображение с элементами поверх него */}
      <div className="card-image-wrapper">
        {/* Бейджи */}
        <div className="card-badges">
          {isHit && <span className="badge hit">🔥 Хит</span>}
          {isNew && <span className="badge new">✨ Новое</span>}
          {discount > 0 && <span className="badge discount">-{discount}%</span>}
          {isSoon && <span className="badge soon">🚀 Скоро</span>}
        </div>

        {/* Кнопка лайка */}
        <LikeButton
          productId={id}
          collectionName={collectionName}
          initialLikes={likes}
        />

        {!imageLoaded && <div className="image-shimmer" />}
        
        <img
          src={compressedImage}
          alt={name}
          className={`card-image ${imageLoaded ? 'loaded' : ''}`}
          onLoad={() => setImageLoaded(true)}
          loading="lazy"
        />
        <div className="image-gradient"></div>
      </div>

      {/* Контентная часть */}
      <div className="card-content">
        {!isSoon ? (
          <>
            <div className="card-header">
              <h3 className="card-title">{name}</h3>
              {/* Теги-пилюли вместо текста через точку */}
              <div className="card-specs">
                {size && <span className="spec-pill">Ø {size} см</span>}
                {gramm && <span className="spec-pill">{gramm}</span>}
              </div>
            </div>

            <p className="card-description">{description}</p>

            <div className="card-footer">
              <div className="card-price">
                {old_price && (
                  <div className="price-old">
                    <span className="old-value">{old_price} ₽</span>
                  </div>
                )}
                <div className="price-current">
                  <span className="current-number">{price}</span>
                  <span className="current-currency">₽</span>
                </div>
              </div>
              
              {/* Используем ваш новый Button.js */}
              <Button onClick={handleOrderClick} className="card-buy-btn">
                Заказать
              </Button>
            </div>
          </>
        ) : (
          <div className="soon-content">
            <div className="soon-emoji-wrapper">
              <span className="soon-emoji">🚀</span>
            </div>
            <h4 className="soon-title">Скоро в продаже</h4>
            <p className="soon-desc">Этот товар появится совсем скоро. Следите за обновлениями!</p>
          </div>
        )}
      </div>
    </div>
  );
});

export default ProductCard;